import { render } from "./TenantsOverview.vue?vue&type=template&id=6158757c&scoped=true&ts=true"
import script from "./TenantsOverview.vue?vue&type=script&lang=ts"
export * from "./TenantsOverview.vue?vue&type=script&lang=ts"

import "./TenantsOverview.vue?vue&type=style&index=0&id=6158757c&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6158757c"]])

export default __exports__